<template lang="pug">
  v-container( fluid )
      v-toolbar( color='primary' dark flat )
        v-toolbar-title.subheading.font-weight-medium.text-uppercase clientes asociados
        v-spacer
        v-toolbar-items
          v-btn(
            :disabled="disabled"
            @click="toggleEditable()"
            flat
            ) editar
      div( v-if="editable" )
        ModelForm(
          :fields="formFields"
          v-bind="formData"
          @submit="submitForm( $event )"
          v-model="customerData"
          )
      v-list( class='py-0' two-line )
        template( v-for='(item, index) in items' )
          v-list-tile( :class='index % 2 > 0 ? "grey lighten-4" : ""' )
            v-list-tile-avatar( color='secondary white--text' ) {{ item.business_name.charAt(0) }}
            v-list-tile-content
              v-list-tile-title( v-text="item.business_name" )
              v-list-tile-sub-title( v-text="item.branch_offices.map(b => b.address).join(' ,')" )
            v-list-tile-action
              v-btn( icon v-if="editable" )
                v-icon( @click="showCustomerDeleteSnackbar( item )" color="red" ) delete
          v-list-tile( v-if="items.length === 0" )
            v-list-tile-content
              v-list-tile-sub-title Sin clientes asignados
          v-divider
</template>

<script>
//
import { mapActions } from 'vuex'
//
import ModelForm from '@/components/reusable_components/next/model-form'
import CurrencyUtils from '@/mixins/CurrencyUtils.js'
import InputValidations from '@/mixins/InputValidations.js'
//
import CustomerService from '@/services/api/customer/CustomerService'
import UserSellerService from '@/services/api/userSeller'
//
import SlCustomer from '@/models/Sale/SlCustomer'
import SlCustomerBranchOffices from '@/models/Sale/SlCustomerBranchOffices'
//
export default {
    components: {
        ModelForm,
    },
    props: {
        disabled: {
            type: Boolean,
            default: false,
        },
        value: {
            type: Array,
            default: [],
        },
    },
    data() {
        //
        return {
            editable: false,
            formData: {
                submitText: 'Agregar cliente',
            },
            customerData: {},
            branchOffices: [],
        }
    },
    computed: {
        items: {
            get() {
                return this.value
            },
            set(v) {
                this.$emit('input', v)
            },
        },
        formFields() {
            let loadCustomer = this.loadCustomer
            return [
                {
                    name: 'customer',
                    type: 'autocomplete-model',
                    value: '',
                    flex: {
                        xs6: true,
                    },
                    props: {
                        label: 'Cliente',
                        model: SlCustomer,
                        itemText: 'alias_name',
                        returnObject: true,
                    },
                    trigger: ctx => loadCustomer(ctx.value.customer),
                    rules: ['required'],
                },
                {
                    name: 'business_name',
                    props: {
                        label: 'Razón Social',
                        readonly: true,
                    },
                    flex: {
                        xs6: true,
                    },
                    type: 'text-field',
                    value: '',
                    rules: ['required'],
                },
                {
                    name: 'rut',
                    props: {
                        label: 'RUT',
                        readonly: true,
                    },
                    flex: {
                        xs6: true,
                    },
                    type: 'text-field',
                    value: '',
                    rules: ['required'],
                },
                {
                    name: 'sl_customer_branch_office_id',
                    props: {
                        label: 'Dirección',
                        noDataText: 'Sin sucursales',
                        items: this.branchOffices,
                        itemText: 'address',
                        itemValue: 'id',
                    },
                    flex: {
                        xs6: true,
                    },
                    type: 'select',
                    value: '',
                    rules: ['required'],
                },
            ]
        },
    },
    methods: {
        getBranchOffices() {
            return SlCustomerBranchOffices
                .where('sl_customer_id', this.customerData.id)
                .where('is_available_ground_seller', true)
                .get()
        },
        setBranchOffices(res) {
            this.branchOffices = res.data
        },
        loadCustomer(customer) {
            console.log(customer)
            if (!customer) {this.customerData = {}}
            else{
                this.customerData = {
                    id: customer.id,
                    customer: this.customerData.customer,
                    rut: customer.rut,
                    business_name: customer.business_name,
                    address:
                        customer.branch_offices &&
                        customer.branch_offices.length
                            ? customer.branch_offices.find(
                                  o => o.default_branch_office
                              ).address
                            : '',
                }
                this.getBranchOffices()
                    .then(this.setBranchOffices)
            }
        },
        ...mapActions('MenuesModule', {
            setTitleTopBar: 'setTitleTopBar',
        }),
        ...mapActions('SnackbarModalModule', {
            initSnackbar: 'initSnackbar',
            resetSnackbarState: 'resetSnackbarState',
            setMessageConfirmSnack: 'setMessageConfirmSnack',
        }),
        async refresh() {
            //
            let id = this.$route.params.id
            //
            this.setUserData(await UserSellerService.fetchById(id))
            this.setCustomersData(
                await CustomerService.fetchAllAvailableGroundSeller()
            )
        },
        setCustomersData(data) {
            this.formFields[0].options.data = [...data]
        },
        setSelectedCustomerId(item) {
            //
            let selectedCustomerData = this.formFields[0].options.data.find(
                customer => customer.id === item.id
            )
            //
            this.formFields[0].value = selectedCustomerData.id
            this.formFields[1].value = selectedCustomerData.business_name
            this.formFields[2].value = selectedCustomerData.rut
            this.formFields[3].value = selectedCustomerData.branch_offices
                .filter(office => office.default_branch_office)
                .slice()
                .pop().address
            //
            this.formFields = [...this.formFields]
        },
        setUserData(data) {
            this.items = [...data.customers]
        },
        async showSnackbar(type, title, message, callback = () => {}) {
            this.initSnackbar(this.fillSnack(type, title, message, false, 3000))
            callback()
        },
        async showCustomerDeleteSnackbar(customer) {
            let id = this.$route.params.id
            let user = await UserSellerService.fetchById(id)
            //
            console.log('asdfdsf', user)
            user.customers = [
                ...user.customers
                    .filter(({ id }) => customer.id !== id)
                    .map(customer => customer.id),
            ]
            //
            let response = await UserSellerService.update(id, {
                commissions: user.commissions.map(commission => commission.id),
                customers: user.customers,
                email: user.hr_employee.email,
                is_ground_seller: user.is_ground_seller,
                last_name1: user.hr_employee.last_name1,
                last_name2: user.hr_employee.last_name2,
                names: user.hr_employee.names,
                role: 3,
                rut: user.hr_employee.rut,
                seller_type: user.seller_type,
                g_branch_office_id: user.hr_employee.g_branch_office_id,
            })
            //
            switch (response.status) {
                case 'success':
                    return this.showSnackbar(
                        'success',
                        'Exito.',
                        'Cliente eliminado exitosamente.',
                        this.refresh
                    )
                case 'error':
                    return this.showSnackbar(
                        'error',
                        'Error.',
                        response.message + ': ' + response.error + '.'
                    )
            }
        },
        async submitForm() {
            let customer = null
            try {
                console.log('asdf', this.customerData.customer)
                customer = this.customerData.sl_customer_branch_office_id
            } catch (e) {
                return alert('primero seleccione un cliente')
            }
            if (!customer) return alert('primero seleccione un cliente')
            //
            //
            let id = this.$route.params.id
            let user = await UserSellerService.fetchById(id)
            //
            user.customer_branch_offices = [
                ...user
                    .customers
                    .reduce((e, c) => [ ...e, ...c.branch_offices.map(b => b.id) ], []),
                customer,
            ]
            //
            let response = await UserSellerService.update(id, {
                commissions: user.commissions.map(commission => commission.id),
                customer_branch_offices: user.customer_branch_offices,
                email: user.hr_employee.email,
                is_ground_seller: false,
                last_name1: user.hr_employee.last_name1,
                last_name2: user.hr_employee.last_name2,
                names: user.hr_employee.names,
                // role: 3,
                g_branch_office_id: user.hr_employee.g_branch_office_id,
                seller_type: user.seller_type,
                rut: user.hr_employee.rut,
            })
            //
            switch (response.status) {
                case 'success':
                    this.customerData = {}
                    return this.showSnackbar(
                        'success',
                        'Exito.',
                        'Cliente asignado exitosamente.',
                        this.refresh,
                        this.toggleEditable()
                    )
                case 'error':
                    return this.showSnackbar(
                        'error',
                        'Error.',
                        response.message + ': ' + response.error + '.'
                    )
            }
        },
        toggleEditable() {
            this.editable = !this.editable
        },
    },
    async mounted() {
        //
        let id = this.$route.params.id
        //
        this.setUserData(await UserSellerService.fetchById(id))
        /*
        this.setCustomersData(
            await CustomerService.fetchAllAvailableGroundSeller()
        )
        */
    },
    mixins: [InputValidations, CurrencyUtils],
    name: 'customers-list',
}
</script>
